var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2806_12587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33203 7.99992C1.33203 4.31992 4.31203 1.33325 7.99203 1.33325C11.6787 1.33325 14.6654 4.31992 14.6654 7.99992C14.6654 11.6799 11.6787 14.6666 7.99203 14.6666C4.31203 14.6666 1.33203 11.6799 1.33203 7.99992ZM10.6454 5.33325H12.612C11.972 4.23325 10.952 3.37992 9.72536 2.95992C10.1254 3.69992 10.432 4.49992 10.6454 5.33325ZM7.9987 2.69325C8.55203 3.49325 8.98536 4.37992 9.27203 5.33325H6.72536C7.01203 4.37992 7.44536 3.49325 7.9987 2.69325ZM2.66536 7.99992C2.66536 8.45992 2.73203 8.90658 2.8387 9.33325H5.09203C5.0387 8.89325 4.9987 8.45325 4.9987 7.99992C4.9987 7.54659 5.0387 7.10659 5.09203 6.66658H2.8387C2.73203 7.09325 2.66536 7.53992 2.66536 7.99992ZM3.38536 10.6666H5.35203C5.56536 11.4999 5.87203 12.2999 6.27203 13.0399C5.04536 12.6199 4.02536 11.7733 3.38536 10.6666ZM3.38536 5.33325H5.35203C5.56536 4.49992 5.87203 3.69992 6.27203 2.95992C5.04536 3.37992 4.02536 4.22659 3.38536 5.33325ZM7.9987 13.3066C7.44536 12.5066 7.01203 11.6199 6.72536 10.6666H9.27203C8.98536 11.6199 8.55203 12.5066 7.9987 13.3066ZM6.4387 9.33325H9.5587C9.6187 8.89325 9.66536 8.45325 9.66536 7.99992C9.66536 7.54659 9.6187 7.09992 9.5587 6.66658H6.4387C6.3787 7.09992 6.33203 7.54659 6.33203 7.99992C6.33203 8.45325 6.3787 8.89325 6.4387 9.33325ZM9.72536 13.0399C10.1254 12.2999 10.432 11.4999 10.6454 10.6666H12.612C11.972 11.7666 10.952 12.6199 9.72536 13.0399ZM10.9987 7.99992C10.9987 8.45325 10.9587 8.89325 10.9054 9.33325H13.1587C13.2654 8.90658 13.332 8.45992 13.332 7.99992C13.332 7.53992 13.2654 7.09325 13.1587 6.66658H10.9054C10.9587 7.10659 10.9987 7.54659 10.9987 7.99992Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2806_12587)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#A6B0CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.c6cec1c0.svg";
export { ForwardRef as ReactComponent };